function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module font/fontfamily/fontfamilyediting
 */
import { Plugin } from 'ckeditor5/src/core';
import FontFamilyCommand from './fontfamilycommand';
import { normalizeOptions } from './utils';
import { buildDefinition, FONT_FAMILY } from '../utils';
/**
 * The font family editing feature.
 *
 * It introduces the {@link module:font/fontfamily/fontfamilycommand~FontFamilyCommand command} and
 * the `fontFamily` attribute in the {@link module:engine/model/model~Model model} which renders
 * in the {@link module:engine/view/view view} as an inline `<span>` element (`<span style="font-family: Arial">`),
 * depending on the {@link module:font/fontfamily~FontFamilyConfig configuration}.
 *
 * @extends module:core/plugin~Plugin
 */

var FontFamilyEditing =
/*#__PURE__*/
function (_Plugin) {
  _inherits(FontFamilyEditing, _Plugin);

  _createClass(FontFamilyEditing, null, [{
    key: "pluginName",

    /**
     * @inheritDoc
     */
    get: function get() {
      return 'FontFamilyEditing';
    }
    /**
     * @inheritDoc
     */

  }]);

  function FontFamilyEditing(editor) {
    var _this;

    _classCallCheck(this, FontFamilyEditing);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FontFamilyEditing).call(this, editor)); // Define default configuration using font families shortcuts.

    editor.config.define(FONT_FAMILY, {
      options: ['default', 'Arial, Helvetica, sans-serif', 'Courier New, Courier, monospace', 'Georgia, serif', 'Lucida Sans Unicode, Lucida Grande, sans-serif', 'Tahoma, Geneva, sans-serif', 'Times New Roman, Times, serif', 'Trebuchet MS, Helvetica, sans-serif', 'Verdana, Geneva, sans-serif'],
      supportAllValues: false
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(FontFamilyEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor; // Allow fontFamily attribute on text nodes.

      editor.model.schema.extend('$text', {
        allowAttributes: FONT_FAMILY
      });
      editor.model.schema.setAttributeProperties(FONT_FAMILY, {
        isFormatting: true,
        copyOnEnter: true
      }); // Get configured font family options without "default" option.

      var options = normalizeOptions(editor.config.get('fontFamily.options')).filter(function (item) {
        return item.model;
      });
      var definition = buildDefinition(FONT_FAMILY, options); // Set-up the two-way conversion.

      if (editor.config.get('fontFamily.supportAllValues')) {
        this._prepareAnyValueConverters();

        this._prepareCompatibilityConverter();
      } else {
        editor.conversion.attributeToElement(definition);
      }

      editor.commands.add(FONT_FAMILY, new FontFamilyCommand(editor));
    }
    /**
     * These converters enable keeping any value found as `style="font-family: *"` as a value of an attribute on a text even
     * if it is not defined in the plugin configuration.
     *
     * @private
     */

  }, {
    key: "_prepareAnyValueConverters",
    value: function _prepareAnyValueConverters() {
      var editor = this.editor;
      editor.conversion["for"]('downcast').attributeToElement({
        model: FONT_FAMILY,
        view: function view(attributeValue, _ref) {
          var writer = _ref.writer;
          return writer.createAttributeElement('span', {
            style: 'font-family:' + attributeValue
          }, {
            priority: 7
          });
        }
      });
      editor.conversion["for"]('upcast').elementToAttribute({
        model: {
          key: FONT_FAMILY,
          value: function value(viewElement) {
            return viewElement.getStyle('font-family');
          }
        },
        view: {
          name: 'span',
          styles: {
            'font-family': /.*/
          }
        }
      });
    }
    /**
     * Adds support for legacy `<font face="..">` formatting.
     *
     * @private
     */

  }, {
    key: "_prepareCompatibilityConverter",
    value: function _prepareCompatibilityConverter() {
      var editor = this.editor;
      editor.conversion["for"]('upcast').elementToAttribute({
        view: {
          name: 'font',
          attributes: {
            'face': /.*/
          }
        },
        model: {
          key: FONT_FAMILY,
          value: function value(viewElement) {
            return viewElement.getAttribute('face');
          }
        }
      });
    }
  }]);

  return FontFamilyEditing;
}(Plugin);

export { FontFamilyEditing as default };